import React from 'react';
import 'pages/notifications/index.scss';

import NotificationsCenter from 'pages/notifications/containers/notifications/notificationsCenter';

const Notifications = () => {
  return (
    <div className="row">
      <NotificationsCenter />
    </div>
  );
};

export default Notifications;
